import * as React from "react";
import * as SFMLWeb from "@flipp/sfml-web";
import jsPDF from "jspdf";

import { HeatmapLegend } from "../../../core/Chart/Heatmap";
import { SFMLProps, SFMLActions } from "./container";

import { Spin } from "../../../core/Spin";

import { renderStorefront } from "../SFML/sfml";

import "./style.scss";

interface SFMLState<T> {
  showSpinner: T;
}

interface SFML {
  storefront: any;
  storefrontId: string;
}

class SFML extends React.Component<
  SFMLProps & SFMLActions,
  SFMLState<boolean>
> {
  constructor(props: SFMLProps & SFMLActions) {
    super(props);
    this.state = {
      showSpinner: true
    };
    this.storefront = null;
    this.storefrontId = props.fullscreen
      ? `storefront-fullscreen`
      : "storefront";
  }

  componentDidMount() {
    if (this.props.fullscreen) {
      this.renderSFML(this.props);
    }
  }

  componentWillReceiveProps(nextProps: SFMLProps) {
    if (!nextProps.flyerItemsLoading && this.props.flyerItemsLoading) {
      this.props.getSfmlData();
    }

    if (this.props.sfmlData === null && nextProps.sfmlData !== null) {
      this.renderSFML(nextProps);
    }

    if (
      this.props.sfmlErrorMessage === null &&
      nextProps.sfmlErrorMessage !== null
    ) {
      document.querySelector(`#${this.storefrontId}`).innerHTML = "";
    }
  }

  handlePDFClick = (i: number) => (event: MouseEvent) => {
    const canvas = (event.target as Element)
      .nextElementSibling as HTMLCanvasElement;

    const pageWidth = canvas.width;
    const pageHeight = canvas.height;
    const scale = canvas.width / canvas.offsetWidth;

    const newCanvas = document.createElement("canvas");
    newCanvas.width = pageWidth;
    newCanvas.height = pageHeight;

    const newCtx = newCanvas.getContext("2d");
    newCtx.drawImage(canvas, 0, 0);

    const blocks = canvas.nextElementSibling.querySelectorAll("a");

    blocks.forEach((a) => {
      a.style.display = "block";

      const x = Number.parseFloat(a.style.left) * scale;
      const y = Number.parseFloat(a.style.top) * scale;
      const w = Number.parseFloat(a.style.width) * scale;
      const h = Number.parseFloat(a.style.height) * scale;

      const children = a.querySelectorAll("div");

      if (!children.length) return;

      const color = children[0].style.backgroundColor || "transparent";

      newCtx.fillStyle = color;
      newCtx.fillRect(x, y, w, h);
    });

    const imgData = newCanvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF("p", "px", [pageWidth / scale, pageHeight / scale]);
    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      newCanvas.width / scale,
      newCanvas.height / scale
    );
    pdf.save(`page_${i + 1}.pdf`);
  };

  setupDownloadButtons = () => {
    const buttons = document.querySelectorAll(
      "a[wayfinder-anchor]:not([init])"
    );

    buttons.forEach((button: HTMLAnchorElement, i) => {
      button.innerText = "PDF";
      button.setAttribute("init", "1");
      button.onclick = this.handlePDFClick(i);
    });
  };

  renderSFML(nextProps: SFMLProps) {
    this.storefront = renderStorefront(
      nextProps.sfmlData.children[0],
      this.props.store,
      this.storefrontId
    );
    setTimeout(() => {
      SFMLWeb.AspectResizer.shared.resize(this.storefront);
    }, 0);

    window.addEventListener("resize", () => {
      SFMLWeb.AspectResizer.shared.resize(this.storefront);
    });

    this.setupDownloadButtons();

    this.setState({ showSpinner: false });
  }

  render() {
    const { sfmlErrorMessage, fullscreen } = this.props;
    const style = sfmlErrorMessage ? { textAlign: "center" } : null;
    return (
      <div id="sfml">
        {!fullscreen && (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <HeatmapLegend />
          </div>
        )}
        <div id="sfml-wrapper">
          <div style={style}>
            {this.state.showSpinner && (
              <div id="sfml-spinner">
                <Spin />
              </div>
            )}
            {sfmlErrorMessage ? sfmlErrorMessage : null}
          </div>
          <div id={this.storefrontId} />
        </div>
      </div>
    );
  }
}

export default SFML as any;



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/SFML/component.tsx